import React, { useState } from 'react';
import QuickFacts from './QuickFacts';
import UpdateDetails from './UpdateDetails';
import SignInOptions from '../Auth/SignInOptions';

interface TabbedSectionProps {
  stats: {
    total_generated_kwh: number;
    co2_saved_tonnes: string;
  };
}

const TabbedSection: React.FC<TabbedSectionProps> = ({ stats }) => {
  const [activeTab, setActiveTab] = useState<'quickfacts' | 'updatedetails' | 'signinoptions'>('quickfacts');

  return (
    <div className="bg-white rounded-lg shadow-sm mb-6 sm:mb-8">
      {/* Tab Headers */}
      <div className="border-b border-gray-200">
        <div className="grid grid-cols-3">
          <button
            onClick={() => setActiveTab('quickfacts')}
            className={`px-3 sm:px-6 py-3 text-xs sm:text-sm font-medium border-b-2 transition-colors ${
              activeTab === 'quickfacts'
                ? 'border-shade-green-600 text-shade-green-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Quick Facts
          </button>
          <button onClick={() => setActiveTab('signinoptions')}
            className={`px-3 sm:px-6 py-3 text-xs sm:text-sm font-medium border-b-2 transition-colors ${activeTab === 'signinoptions' ? 'border-shade-green-600 text-shade-green-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}>
            Sign-in options
          </button>
          <button
            onClick={() => setActiveTab('updatedetails')}
            className={`px-3 sm:px-6 py-3 text-xs sm:text-sm font-medium border-b-2 transition-colors ${
              activeTab === 'updatedetails'
                ? 'border-shade-green-600 text-shade-green-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Update Details
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div className="p-4 sm:p-6">
        {activeTab === 'quickfacts' ? (
          <QuickFacts stats={stats} />
        ) : activeTab === 'updatedetails' ? (
          <UpdateDetails />
        ) : <SignInOptions />}
      </div>
    </div>
  );
};

export default TabbedSection;
